<template>
  <v-footer v-if="!isAgentReserveSite" class="site-footer pa-0 white">
    <v-container class="text-center">
      <!-- Logo -->
      <v-row justify="center" class="mb-8">
        <v-col cols="12" class="d-flex justify-center">
          <img
            v-if="settings.logo"
            :src="settings.logo"
            alt="Logo"
            height="50"
            class="footer-logo"
          />
        </v-col>
      </v-row>

      <!-- Business Info -->
      <div style="max-width: 800px; margin: 0 auto">
        <v-row justify="center" class="mb-8">
          <v-col cols="12" sm="3">
            <router-link
              class="text-capitalize ml-2 no-letter-spacing text-decoration-none font-18"
              to="/"
              >{{ $t("home") }}</router-link
            >
          </v-col>
          <v-col cols="12" sm="3">
            <router-link
              class="text-capitalize ml-2 no-letter-spacing text-decoration-none font-18"
              to="/listings"
              >{{ $t("search") }}</router-link
            >
          </v-col>
          <v-col cols="12" sm="3">
            <router-link
              class="text-capitalize ml-2 no-letter-spacing text-decoration-none font-18"
              to="/about"
              >{{ $t("about_us") }}</router-link
            >
          </v-col>
          <v-col cols="12" sm="3">
            <router-link
              class="text-capitalize ml-2 no-letter-spacing text-decoration-none font-18"
              to="/contact"
              >{{ $t("contact") }}</router-link
            >
          </v-col>
        </v-row>
      </div>
      <!-- Social Links -->
      <v-row justify="center" class="mb-8">
        <v-col cols="auto">
          <div class="d-flex justify-center">
            <a
              v-if="settings.social_links?.facebook"
              :href="settings.social_links.facebook"
              target="_blank"
              class="social-link mx-2"
            >
              <div class="social-container">
                <v-icon size="40">mdi-facebook</v-icon>
              </div>
            </a>
            <a
              v-if="settings.social_links?.instagram"
              :href="settings.social_links.instagram"
              target="_blank"
              class="social-link mx-2"
            >
              <div class="social-container">
                <v-icon size="40">mdi-instagram</v-icon>
              </div>
            </a>
          </div>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" class="mb-2">
          <v-row class="business-info justify-center">
            <v-col
              cols="12"
              sm="6"
              md="3"
              class="py-1"
              v-if="settings.business?.name"
            >
              <div class="info-value grey--text">
                {{ settings.business.name }}
              </div>
            </v-col>
            <v-col
              cols="12"
              sm="6"
              md="3"
              class="py-1"
              v-if="settings.business?.phone"
            >
              <a
                :href="`tel:${settings.business.phone}`"
                class="info-value grey--text text-decoration-underline phone-link"
              >
                {{ $t("tel") }} {{ settings.business.phone }}
              </a>
            </v-col>
            <v-col
              cols="12"
              sm="6"
              md="3"
              class="py-1"
              v-if="settings.business?.email"
            >
              <div class="info-value grey--text">
                {{ $t("email_label") }} {{ settings.business.email }}
              </div>
            </v-col>
            <v-col
              cols="12"
              sm="6"
              md="3"
              class="py-1"
              v-if="settings.business?.address"
            >
              <div class="info-value grey--text">
                {{ settings.business.address }}
              </div>
            </v-col>
          </v-row>
        </v-col>
      </v-row>

      <!-- Footer Links -->
    </v-container>
    <v-container fluid class="pa-0">
      <v-row
        no-gutters
        class="grey lighten-3 mt-6 py-3"
        :class="{ 'mobile-margin-bottom': isMobile }"
      >
        <v-col cols="12" sm="3" class="py-1 py-sm-4">
          <div class="grey--text text-center w-100">
            {{ $t("copyright") }} &copy; {{ new Date().getFullYear() }}
            {{ settings.business?.name }}
          </div>
        </v-col>
        <v-col cols="12" sm="3" class="py-1 py-sm-4">
          <div class="grey--text text-center w-100">
            {{ $t("all_rights_reserved") }}
          </div>
        </v-col>
        <v-col cols="12" sm="3" class="py-1 py-sm-4 text-center">
          <router-link
            :to="settings?.pages?.terms?.active ? '/terms' : { name: 'terms' }"
            class="grey--text text-center w-100 text-decoration-none"
          >
            {{ $t("terms_and_conditions") }}
          </router-link>
        </v-col>
        <v-col cols="12" sm="3" class="py-1 py-sm-4 text-center">
          <router-link
            :to="
              settings?.pages?.privacy?.active
                ? '/privacy'
                : { name: 'privacy' }
            "
            class="grey--text text-center w-100 text-decoration-none"
          >
            {{ $t("privacy_policy") }}
          </router-link>
        </v-col>
      </v-row>
    </v-container>
  </v-footer>
</template>

<script>
import { COMPANY_NAME } from "@/consts/CMS";
import MediaMixin from "@/mixins/media-mixin";
import { mapState } from "vuex";
import DeviceMixin from "@/mixins/device-mixin";

export default {
  name: "site-footer",
  mixins: [MediaMixin, DeviceMixin],
  data: () => ({
    COMPANY_NAME,
  }),
  computed: {
    ...mapState({
      settings: (state) => state.settingsModule.settings,
    }),
    isAgentReserveSite() {
      return this.settings.site_type === "agent_reserve";
    },
  },
};
</script>

<style lang="scss" scoped>
.footer-logo {
  opacity: 0.5;
}

.social-link {
  text-decoration: none;
  transition: transform 0.2s;

  &:hover {
    transform: translateY(-2px);

    .social-container {
      background-color: #f3f4f6;
    }
  }
}

.footer-link {
  color: white;
  text-decoration: none;
  font-size: 14px;
  transition: opacity 0.2s;

  &:hover {
    opacity: 0.8;
  }
}

@media (max-width: 600px) {
  .business-info {
    text-align: center;
  }
}

.font-18 {
  font-size: 18px;
}

.mobile-margin-bottom {
  margin-bottom: 80px;
}
</style>
